import React, {Component} from 'react';
import Select from 'react-select';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import classNames from 'classnames';
import * as addressSearchActions from "../../actions/addressSearchActions";
import * as companyActions from "../../actions/companyActions";
import { injectIntl } from 'react-intl';
import {messages} from  '../common/Translations';

class CompanyAddress extends React.Component {
    constructor(props) {
        super(props);
        this.onInputChange = this.onInputChange.bind(this);
        this.onChange = this.onChange.bind(this);
    }

    componentDidMount() {
        if(this.props.addressId) {
            this.props.actions.preloadAddresses(this.formatSearchParams('', this.props));
        }
    }

    componentWillReceiveProps(nextProps) {
        if (this.isEdit(nextProps)) {
            if (this.areValuesInitialized(nextProps)) {
                this.props.actions.preloadAddresses(this.formatSearchParams('', nextProps));
            }
        }
    }

    isEdit(nextProps) {
        return this.props.input.value !== nextProps.input.value && this.props.addressPreLoaded === false;
    }

    areValuesInitialized(nextProps) {
        return this.props.regionId !== nextProps.regionId && this.props.municipalityId !== nextProps.municipalityId;
    }

    onInputChange(text) {
        if (this.checkParams(text, this.props)) {
            this.props.actions.searchCompanyAddress(this.formatSearchParams(text, this.props));
        }
    }

    onChange(addressId) {
        if (this.props.input.onChange && addressId !== null) {
            this.props.input.onChange(addressId);
            this.props.actions.updateCompanyAddressId(addressId);
            this.props.actions.getAddressDetails(addressId);
        } else {
            this.props.input.onChange(null)
        }
    }


    checkParams(text, props) {
        return props.regionId !== '' &&
            props.municipalityId !== '' &&
            text !== ''
    }

    formatSearchParams(text, props) {
        return {
            searchString: text,
            municipalityId: props.municipalityId,
            regionId: props.regionId,
            id: props.addressId
        }
    }

    render() {
        let error = null;
        if(this.props.meta.touched && this.props.meta.error) {
            error = this.props.meta.error;
        }

        return (
            <div>
                <Select
                    {...this.props}
                    value={this.props.input.value}
                    options={this.props.addressSearchResult}
                    onChange={(value) => this.onChange(value)}
                    onInputChange={this.onInputChange}
                    clearable={false}
                    simpleValue={true}
                    placeholder={this.props.intl.formatMessage(messages.addressPlaceholder)}
                    onBlur={() => this.props.input.onBlur(this.props.input.value)}
                />
                <div className={classNames('form-control-feedback', 'error-block', 'text-danger', {'hidden-xs-up': !error})}>
                    {error}
                </div>
            </div>

        );
    }
}

function mapStateToProps(state, ownProps) {
    return {};
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(
            Object.assign(
                {},
                companyActions,
                addressSearchActions,
            ), dispatch
        )
    }

}

export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(CompanyAddress));





// WEBPACK FOOTER //
// ./web/src/components/company/CompanyAddress.jsx